import React from 'react'
import { Typography, Card, Divider } from 'antd'
import styled from 'styled-components'
import { FlexRow } from '../Components/FlexboxReusables/FlexItems'

const { Title, Paragraph } = Typography

const Imprint: React.FC = () => {
  return (
    <FlexRow>
      <ImprintContainer>
        <Title level={2}>Postanschrift:</Title>
        <Paragraph>
        et360° GmbH
          < br />
        Auweg 27
          < br />
        63920 Großheubach
        </Paragraph>
        <Divider />
        <Title level={2}>Kontakt:</Title>
        <Paragraph>
        Fon: 09371 / 9119036-0
          < br />
        Fax: 09371 / 9119036-9
          < br />
          <a href="mailto:info@et360.de">eMail: info@et360.de</a>
        </Paragraph>
        <Divider />
        <Title level={2}>Unternehmensdetails:</Title>
        <Paragraph>
        Sitz der Gesellschaft:
          < br />
        Auweg 27, 63920 Großheubach, Deutschland
          < br />
        Registergericht: HRB Aschaffenburg
          < br />
        UST-ID Nr.: DE 300 011 732
          < br />
        Geschäftsführer: Markus Fuchs, Raffael Holz
        </Paragraph>
        <Divider />
        <Title level={2}>Haftungsausschluss:</Title>
        <Paragraph>
        Alle in unseren Internetseiten enthaltenen Angaben und Informationen wurden von uns sorgfältig recherchiert und geprüft. Für die Richtigkeit, Vollständigkeit und Aktualität können wir jedoch keine Gewähr übernehmen. Dies gilt auch für die Internetseiten unserer Partner und Kooperationen, zu denen Sie über Hyperlink gelangen; für diesen Inhalt übernehmen wir keine Verantwortung.
        Insbesondere behalten wir uns das Recht vor, Änderungen oder Ergänzungen der bereitgestellten Informationen vorzunehmen. Für automatisch aus dem deutschen in andere Sprachen übersetzte Inhalte übernehmen wir keine Haftung.
        Inhalt und Gestaltung der Internetseiten sind urheberrechtlich geschützt. Eine Vervielfältigung der Seiten oder deren Inhalte bedarf unserer vorherigen schriftlichen Zustimmung.
        </Paragraph>
      </ImprintContainer>
    </FlexRow>
  )
}

export default Imprint

const ImprintContainer = styled(Card)`
  max-width: 800px;
  margin: 0 auto;
  padding: 24px;
`